module.exports = __webpack_public_path__ + "img/Revenue Icon - white.eef7cc15.svg";